import React from "react";
import { useParams } from "react-router-dom";
import data from "../../json/Agiletesting/Agiletesting1.json";

const Agilitesting1 = () => {
  const { testing } = useParams();
  console.log(testing);

  return (
    <div
      className="agiletestingbg w-full justify-center flex"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/Agiletesting/${testing}.svg)`,
      }}
    >
      <div className="2xl:container flex justify-center p-4 md:p-0 md:px:20 flex-col items-center w-full md:mt-[72px] mt-8 lg:mt-[72px]">
        {testing !== "webdevelopmenttesting" ? (
          <div className="flex flex-col items-center md:items-center md:flex-row gap-6 md:gap-[88px] md:px-20 mb-6 md:mb-[94px]">
            <div className="w-full md:w-7/12 flex flex-col justify-center">
              <p className="text-32 md:text-40 lg:text-[64px] text-white mb-3 md:mb-10">
                {data[testing].title}
              </p>
              <p className="text-16 md:text-18 text-heropara">
                {data[testing].para}
              </p>
            </div>
            <div className="mt-8 md:mt-0 w-full md:w-5/12 flex items-center ">
              <img
                src={process.env.PUBLIC_URL + data[testing].src}
                alt="agile"
              />
            </div>
          </div>
        ) : (
          <div className="text-center md:w-[63%] mb-8 md:mb-[72px]">
            <p className="text-14 md:text-20 font-medium text-7BF2C5">
              {data[testing].para1}
            </p>
            <p className="text-20 md:text-40 text-white font-medium mt-4 md:mt-6">
              {data[testing].para2}
            </p>
            <p className="text-12 md:text-18 text-heropara mt-4 md:w-[88%] mx-auto">
              {data[testing].para3}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Agilitesting1;
